import { get } from '../lib/api';

export function getAgronomists() {
  return get(`/agronomists`);
}
